export default __webpack_public_path__ + "static/media/WStoreWin.45d0946d.png";